module.exports = __webpack_public_path__ + "img/bp-2023.c1d28a7d.png";